import {Button, Col, Row} from 'antd';
import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {translate} from 'react-i18next';
import {GUTTER_SM, MARGIN_MD} from '../../../../../styles/constants';
import {
  addAllFileMappingWizardComponentMapperComponent,
  addFileMappingWizardComponentMapperComponent,
  removeAllFileMappingWizardComponentMapperComponent,
  removeFileMappingWizardComponentMapperComponent,
  selectFileMappingWizardComponentMapperComponent
} from './actions';
import FileMappingComponentList from '../../../../../components/file-mapping-component-list';
import { mappingTypeDefault } from '../utils';

const mapStateToProps = state => ({
  components: state.scenes.dataManager.fileMapping.components.wizard.shared.components,
  selectedColumnName: state.scenes.dataManager.fileMapping.components.wizard.shared.selectedColumnName,
  selectedColumnOriginalName: state.scenes.dataManager.fileMapping.components.wizard.shared.selectedColumnOriginalName,
  selectedColumnNameTempTable: state.scenes.dataManager.fileMapping.components.wizard.shared.selectedColumnNameTempTable,
  selectedCubeComponentCode: state.scenes.dataManager.fileMapping.components.wizard.shared.selectedCubeComponentCode,
  selectedMapping: state.scenes.dataManager.fileMapping.components.wizard.shared.selectedMapping,
  csvHeader: state.scenes.dataManager.fileMapping.components.wizard.shared.csvHeader,
  cube: state.scenes.dataManager.fileMapping.components.wizard.shared.cube
});

const mapDispatchToProps = dispatch => ({
  onComponentAdd: (columnName, originalColumnName, cubeComponentCode, mappingType, tempTableName) =>
    dispatch(addFileMappingWizardComponentMapperComponent(columnName, originalColumnName, cubeComponentCode, mappingType, tempTableName)),
  onComponentAddAll: () =>
    dispatch(addAllFileMappingWizardComponentMapperComponent()),
  onComponentRemove: (columnName, cubeComponentCode) =>
    dispatch(removeFileMappingWizardComponentMapperComponent(columnName, cubeComponentCode)),
  onComponentRemoveAll: () =>
    dispatch(removeAllFileMappingWizardComponentMapperComponent()),
  onComponentSelect: (mapping) =>
    dispatch(selectFileMappingWizardComponentMapperComponent(mapping)),
});

const FileMappingWizardComponentMapper = ({
                                            t,
                                            components,
                                            csvHeader,
                                            cube,
                                            selectedColumnName,
                                            selectedCubeComponentCode,
                                            selectedMapping,
                                            onComponentAdd,
                                            onComponentAddAll,
                                            onComponentRemove,
                                            onComponentRemoveAll,
                                            onComponentSelect,
                                            selectedColumnNameTempTable,
                                            selectedColumnOriginalName,
                                          }) =>                                          
  <Fragment>
    <Row type="flex" justify="space-between" style={{ marginBottom: MARGIN_MD }}>
      <Col>
        <Row type="flex" gutter={GUTTER_SM}>
          <Col>
            <Button
              onClick={() => onComponentAdd(selectedColumnName, selectedColumnOriginalName, selectedCubeComponentCode, mappingTypeDefault, selectedColumnNameTempTable)}
              disabled={selectedColumnName === null || selectedCubeComponentCode === null}
              title={t('scenes.dataManager.fileMapping.wizard.componentMapper.componentAddButton.title')}
              icon="plus"
            />
          </Col>
          <Col>
            <Button
              onClick={() => onComponentAddAll()}
              disabled={csvHeader === null || cube === null}
              title={t('scenes.dataManager.fileMapping.wizard.componentMapper.componentAddAllButton.title')}
              style={{
                'paddingLeft': 6,
                'paddingRight': 6,
                'fontSize': 22
              }}
            >
              ++
            </Button>
          </Col>
          <Col>
            <Button
              onClick={() => selectedMapping
                ? onComponentRemove(selectedMapping.ColumnName, selectedMapping.CubeComponentCode)
                : null
              }
              disabled={selectedMapping === null}
              icon="minus"
              title={t('scenes.dataManager.fileMapping.wizard.componentMapper.componentRemoveButton.title')}
            />
          </Col>
        </Row>
      </Col>
      <Col className="file-mapping__file-mapping__wizardjoined__icons">
        <Button
          disabled={(components || []).length === 0}
          onClick={() => onComponentRemoveAll()}
          icon="delete"
          title={t('scenes.dataManager.fileMapping.wizard.componentMapper.componentRemoveAllButton.title')}
        />
      </Col>
    </Row>
    <FileMappingComponentList
      mappings={components}
      selectedMapping={selectedMapping ? selectedMapping : null}
      onSelect={(mapping) => onComponentSelect(mapping)}
      columnNameKey="ColumnName"
      cubeComponentCodeKey="CubeComponentCode"
    />
  </Fragment>

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(FileMappingWizardComponentMapper);
